import { CircleLoader, PropagateLoader } from 'react-spinners';
import { Box } from '@mui/material/';

import loaderGIF from '../../assets/loader.gif';

import {
    CircularProgressIcon,
}
    from '../../../Utilities/Helpers/IconHelper';
import styled from 'styled-components';

const LoadingContainer = styled.div`
    position: absolute;
    z-index: 99999;
    width: 100%;
    height: 100vh;
    top: 0;
    opacity: 40%;
    // background: var(--bgAccentPrimaryColor);
    background: black;
    display: flex;
    justify-content: center;

    img,
    .loaderIcon {
        position: relative;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    .loaderIcon {
        fill: var(--iconSuccessColor);
        color: var(--iconSuccessColor);
    }
}
`

const Loader = () => {
    return (<LoadingContainer>
        <PropagateLoader className="loaderIcon" color='#17b2a6' size={20} />
    </LoadingContainer>
    );
}

export default Loader;